import { toTitleCase } from './toTitleCase';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SPECIAL_ABBREVIATIONS = ['ICD'];

/**
 * Formats appointment tag labels based on their type:
 *  - Email addresses (e.g., "first.last@email.com"): kept as-is.
 *  - Legacy format (e.g., "EXAMPLE_TAG"): uses title case.
 *  - Categorized format (e.g., "System.EXAMPLE_TAG"): shows title case of key only.
 */
export const formatAppointmentTagLabel = (input: string): string => {
  if (EMAIL_REGEX.test(input)) {
    return input;
  }

  let tag = input;

  if (input.includes('.')) {
    const parts = input.split('.');
    const key = parts[parts.length - 1];
    if (key) {
      tag = key;
    }
  }

  const titleCased = toTitleCase(tag);

  return titleCased
    .split(' ')
    .map((word) => {
      const upperWord = word.toUpperCase();
      return SPECIAL_ABBREVIATIONS.includes(upperWord) ? upperWord : word;
    })
    .join(' ');
};
